<template>
  <b-overlay :show="overlay" rounded="sm">
    <b-row>
      <b-col md="6" sm="12">
        <b-card header="Voeg bestanden toe">
          <b-form @submit.prevent="upload">
            <b-row>
              <b-col cols="12">
                <b-form-group label="Voeg nieuw bestand toe">
                  <b-form-file multiple v-model="files_to_upload" required></b-form-file>
                </b-form-group>
              </b-col>
            </b-row>
            <b-button type="submit" variant="success">Upload!</b-button>
          </b-form>
        </b-card>
      </b-col>

      <b-col md="6" sm="12">
        <b-card header="Voeg video's toe">
          <b-form @submit.prevent="addVideo">
            <b-row>
              <b-col cols="12">
                <b-form-group label="Video titel">
                  <b-form-input type="text" required v-model="title"></b-form-input>
                </b-form-group>
                <b-form-group label="Vimeo link">
                  <b-form-input type="text" required v-model="url"></b-form-input>
                </b-form-group>
                <b-form-group label="Status">
                  <b-form-select :options="positionOptions" required v-model="position"></b-form-select>
                </b-form-group>
              </b-col>
            </b-row>
            <b-button type="submit" variant="success">Opslaan</b-button>
          </b-form>
        </b-card>
      </b-col>

    </b-row>

    <template #overlay>
      <div class="text-center">
        <b-spinner label="Spinning"></b-spinner>
        <p>Bestanden worden verwerkt...</p>
        <!-- We add an SR only text for screen readers -->
        <span class="sr-only">Bestanden worden verwerkt...</span>
      </div>
    </template>

  </b-overlay>
</template>

<script>
import {uploadData, addData} from "@/api";
export default {
  props: {
    options: null
  },

  data() {
    return {
      overlay: false,
      files_to_upload: null,
      title: null,
      url: null,
      position: 'both',

      positionOptions: [
        {'value': 'both', 'text': 'Carousel + Zijkant'},
        {'value': 'carousel', 'text': 'Carousel'},
        {'value': 'sidebar', 'text': 'Zijkant'},
      ],
    };
  },

  methods: {

    upload() {
      let formData = new FormData();

      for (let i = 0; i < this.files_to_upload.length; i++) {
        if(this.files_to_upload[i]['type'] === 'application/pdf') {
          formData.append('project_update_files[]', this.files_to_upload[i])
        } else {
          formData.append('project_update_images[]', this.files_to_upload[i])
        }
      }

      this.overlay = true

      uploadData(`projects/${this.$route.params.id}/updates/${this.$route.params.update_id}/media`, formData).then(({data}) => {
        this.overlay = false;
        this.files_to_upload = null;

        this.$emit('uploadedFiles', data);
      });

    },

    addVideo() {
      this.overlay = true;

      addData(`projects/${this.$route.params.id}/updates/${this.$route.params.update_id}/videos`, {
        title: this.title,
        url: this.url,
        position: this.position
      }).then(response => {
        this.overlay = false;
        this.title = null;
        this.url = null;
        this.position = 'both';

        this.$emit('addedVideo', response.data.data)
      })

    }
  }
}
</script>
